<script setup lang="ts">
import { Dialog } from 'primevue';
import { storeToRefs } from 'pinia';
import { useLanguageStore } from 'shared/translations/stores/languageStore';
import { computed } from 'vue';
import { useAuthStore } from '../store/authStore';

const languageStore = useLanguageStore();
const { translations } = storeToRefs(languageStore);
const authStore = useAuthStore();
const visible = computed(() => !authStore.isUser);

</script>

<template>
  <Dialog
    :header="translations.auth.unauthorized.title"
    :visible="visible"
    position="bottom"
    :modal="false"
    :draggable="false"
    :closable="false"
  >
    <p>{{ translations.auth.unauthorized.description }}</p>
  </Dialog>
</template>
